import PratusSelect from 'components/DesignSystems/New/PratusSelect';
import { StylishNewSearchBar } from 'components/DesignSystems/New/StylishNewSearchBar';
import classNames from 'classnames';

type SelectedOption = {
  value: string;
  label: string;
};

type FilterOption =
  | string
  | {
      value: string;
      label: string;
    };

type ColumnDefinition = {
  key: string;
  label: string;
  filterOptions?: FilterOption[];
};

type ResourceHeaderCardProps = {
  filters: {
    [key: string]: string | string[];
  };
  onFilterChange: (filterType: string, values: string[]) => void;
  columns: ColumnDefinition[];
  grid?: string;
};

const ResourceHeaderCard = ({
  filters,
  onFilterChange,
  columns,
  grid,
}: ResourceHeaderCardProps) => {
  const handleFilterChange = (
    key: string,
    selectedOptions: SelectedOption | SelectedOption[] | null
  ) => {
    const values = Array.isArray(selectedOptions)
      ? selectedOptions.map((opt) => opt.value)
      : selectedOptions
        ? [selectedOptions.value]
        : [];
    onFilterChange(key, values);
  };

  return (
    <div
      className={classNames('resource-header', {
        [grid as string]: !!grid,
        'resources-card-header': !grid,
      })}
    >
      <div></div>
      {columns.map(({ key, label, filterOptions }) => {
        const currentValues = filters[key];
        const valueArray = Array.isArray(currentValues)
          ? currentValues
          : currentValues
            ? [currentValues]
            : [];

        const normalizedOptions = (filterOptions ?? []).map((option) =>
          typeof option === 'string' ? { value: option, label: option } : option
        );

        const selectedValues = valueArray.map((value) => {
          const matchingOption = normalizedOptions.find(
            (option) => option.value === value
          );

          return matchingOption ?? { value, label: value };
        });

        return (
          <div key={key}>
            {label}
            {key === 'name' ? (
              <div className="me-2">
                <StylishNewSearchBar
                  value={valueArray[0] || ''}
                  onChangeSearchTerm={(searchValue: string) =>
                    onFilterChange(key, searchValue ? [searchValue] : [])
                  }
                  placeholder={`Search ${label}...`}
                />
              </div>
            ) : (
              filterOptions &&
              filterOptions.length > 0 && (
                <div className="me-2">
                  <PratusSelect
                    isMulti
                    value={selectedValues}
                    options={normalizedOptions}
                    onChange={(selectedOption) =>
                      handleFilterChange(
                        key,
                        selectedOption as
                          | SelectedOption
                          | SelectedOption[]
                          | null
                      )
                    }
                  />
                </div>
              )
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ResourceHeaderCard;
